//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import common from '../../../api/common.js'
export default {
    data(){
        return {
            doctorData : {},
            skillname: []
        }
    },
    created(){
        var ua = navigator.userAgent.toLowerCase();
        var wptype;
        if(ua.match(/MicroMessenger/i)=="micromessenger") {
            wptype = 'jsapi';
        } else {
            wptype = 'h5';
        }
        if(wptype=='jsapi'){
            if(this.$route.query.code==null){
                this.$doRequest('/api/WeiXin/getUrl',{parameters:window.location.href},res=>{
                    // this.$store.state.url = res.parameters;
                    location.href = res.parameters;
                    // this.$router.push({path: '/'});
                })
            }else{
                this.$doRequest('/api/WeiXin/getOpenId',{parameters:this.$route.query.code},res=>{
                    this.$store.state.openid=res.parameters;
                })
            }
        }
        document.title = '门诊挂号';
        var doctorId = common.getQueryString(window.location.search.substr(1),'doctorid'),
            clinicId = common.getQueryString(window.location.search.substr(1),'clinicid'),
            origin = common.getQueryString(window.location.search.substr(1),'origin');
        if(doctorId != null && doctorId != '' && clinicId != null && clinicId != ''){
            this.$store.state.doctorId = doctorId;
            this.$store.state.clinicId = clinicId;
            this.$store.state.origin = origin;
        }
        this.query();
    },
    methods: {
        query(){
            var data = {
                parameters: this.$store.state.doctorId,
                parametersone: this.$store.state.clinicId
            }
            this.$store.state.userInfo.sessionId = this.$store.state.userInfo.sessionId == null ||  this.$store.state.userInfo.sessionId == '' ? 'haozhongyi' : this.$store.state.userInfo.sessionId;
            this.$doRequest('/api/AppHomePage/Index',data,res=>{
                res.doctorFace = '/'+ res.doctorFace;
                this.doctorData = res;
                this.skillname = res.skillname.split(',');
                this.$store.state.price = res.diagnosticfee;
            })
        },
        routerToPay(){
            if(this.doctorData.diagnosticfee == '0'){
                this.$store.state.free = true;
            }
            this.$router.push({path: '/boundPhone'})
        }
    }
}



// WEBPACK FOOTER //
// ./src/views/systemRegistered/guahao/index.vue